import { render } from "./App.vue?vue&type=template&id=0f1298c6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0f1298c6&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_2718be04d8000a82592499ba4d4d2cef/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__